import React from 'react';

export interface InitialComponentProps {
  width?: string | number;
  height?: string | number;
}

const InitialComponent = ({
  width = 400,
  height = 130,
}: InitialComponentProps) => (
  <rect
    data-testid="SkeletonLoader__InitialComponent"
    x="0"
    y="0"
    rx="5"
    ry="5"
    width={width}
    height={height}
  />
);

export default InitialComponent;
